import { Linkedin } from "lucide-react";
import { EncabezadoSeccion, Reveal } from "../../shared/motion";

// Disertantes: reutiliza el contrato "menciones" (nombre, rol, foto, instagramUrl
// — en contexto formal el enlace puede apuntar a LinkedIn o al perfil que sea).
export default function Menciones({ datos, seccion }) {
  const menciones = datos.menciones || [];
  if (menciones.length === 0) return null;

  return (
    <section className="fe-seccion" aria-label={seccion.titulo}>
      <div className="fe-seccion-interior">
        <EncabezadoSeccion p="fe" etiqueta={seccion.etiqueta} titulo={seccion.titulo} testid="fe-titulo-menciones" />
        <div className="fe-menciones">
          {menciones.map((m, i) => (
            <Reveal key={i} delay={i * 0.06}>
              <figure className="fe-mencion" data-testid={`fe-mencion-${i}`}>
                <img className="fe-mencion-foto" src={m.foto} alt={`Fotografía de ${m.nombre}`} loading="lazy" />
                <figcaption>
                  <p className="fe-mencion-nombre">{m.nombre}</p>
                  <p className="fe-mencion-rol">{m.rol}</p>
                  {m.instagramUrl && (
                    <a
                      className="fe-mencion-ig"
                      href={m.instagramUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label={`Perfil de ${m.nombre}`}
                      data-testid={`fe-enlace-perfil-${i}`}
                    >
                      <Linkedin strokeWidth={1.6} />
                    </a>
                  )}
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
